export default {
  spritzConfigs: {
    proxy: {
      name: 'CoreProxy',
      group: 'LINKUSD',
    },
    syntheticToken: {
      name: 'SyntheticToken',
      group: 'LINKUSD',
    },
    collateralAsset: {
      name: 'CollateralToken',
      group: 'LINKUSD',
    },
    oracle: {
      name: 'Oracle',
      group: 'LINKUSD',
    },
    state: {
      name: 'SpritzState',
      group: 'LINKUSD',
    },
  },
  rewardPools: [
    {
      name: 'TestPool-1',
      pair: 'TestPool-1',
      coreType: 'mozart',
    },
    {
      name: 'TestPool-2',
      pair: 'TestToken',
      hasNoDebtRequirement: true,
    },
  ],
  volatileCollaterals: ['LINKUSD'],
}
